function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M400.645,275.633c-14.921-14.042-28.274-17.582-44.084-17.582c0,0-6.384,0.169-1.303,6.591 c6.722,8.498,55.875,72.606,55.105,125.066c-0.891,60.735-61.031,57.291-61.031,57.291c25.298-48.092,12.55-93.586,8.616-109.521 c-7.45-29.424-22.118-57.897-44.175-85.35c-27.198-34.234-54.632-50.475-82.277-48.728c-11.832-20.409-22.327-36.799-31.522-50.204 C250.053,108.488,217.451,86.88,189.054,0c-6.598,18.43-11.852,32.065-15.799,40.823c-20.063-2.496-64.571-2.495-84.624,0 C84.684,32.065,79.43,18.43,72.832,0C44.361,87.113,11.651,108.099,62.309,153.054c5.389,102.186,26.465,129.361,60.56,178.729 c28.058,40.626,21.066,55.093,34.234,111.271c-99.67,62.788,69.299,38.717,95.5,37.423c67.471-3.281,208.15,37.062,196.977-106.548 C446.343,332.336,427.475,301.11,400.645,275.633z M94.3,95.123c-30.879-2.315-26.51-19.565-11.198-19.077 c8.708,0.277,19.524,6.37,26.993,19.077H94.3z M167.391,95.123h-15.796c7.47-12.707,18.287-18.799,26.994-19.077 C193.904,75.558,198.271,92.808,167.391,95.123z"
}));

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 486.075 486.075",
    style: {
      enableBackground: "new 0 0 486.075 486.075"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.65c7c968.svg";
export { ForwardRef as ReactComponent };